import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {CertificateInterface, SpecialistViewInterface} from '@interfaces/specialist.interface';
import {SpecialistDataFlowService} from '../services/specialist-data-flow.service';
import {PreviewModalService} from '@services/preview-modal.service';
import {UploadedFile} from '@interfaces/file.interface';

@Component({
    selector: 'app-specialist-view-tab-pb',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './specialist-view-tab-pb.component.html'
})

export class SpecialistViewTabPbComponent {
    @Input() specialist: SpecialistViewInterface;

    constructor(
        private dataService: SpecialistDataFlowService,
        private previewService: PreviewModalService,
    ) {
    }

    onAddClick() {
        this.dataService.addPb$.next();
    }

    showCertificate(certificate: CertificateInterface) {
        const files: UploadedFile[] = [];

        if (certificate.file && certificate.file.file_url) {
            files.push(certificate.file);
        }

        if (certificate.file_back && certificate.file_back.file_url) {
            files.push(certificate.file_back);
        }

        this.previewService.show({
            title: 'Удостоверение по правилам безопасности (ПБ)',
            contentBefore: `<p>Номер удостоверения: ${certificate.number}</p>`,
            files: files
        });
    }

    hasCertificate() {
        return Boolean(this.specialist && this.specialist.certificate_pb && this.specialist.certificate_pb.length);
    }
}
